import { eventCollectorClient } from '../api/clients';
import { AnalytikaPayloadType, ApiResponseType } from './dtos/analytika';

export const publishEvent = (payload: AnalytikaPayloadType) => {
  return eventCollectorClient.post<ApiResponseType>('/v3/publish-event', {
    ...payload
  });
};
